// these are the main steps of the customer flow
// each main step can contain its' own granular steps
// e.g. the SIGNATURES step encompasses the actions related to both e-signature and ink signature
const menuSteps: Record<string, number> = {
  VID: 1,
  INSURANCE: 2,
  ADDITIONALINFORMATION: 3,
  SIGNATURES: 4,
  ESIGNATURES: 5,
  INKSIGNATURES: 6,
  FINISH: 7,
};

export default menuSteps;

